export default __webpack_public_path__ + "static/media/gorillaz-band.dd0509f7.png";